import React from 'react';
import { IconProps } from '../types';

export const ECommerceStoresIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_40239)">
            <path d="M5 19V30H27V19" stroke={color} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square" />
            <path
                d="M30.9731 11C30.8501 12.1002 30.3259 13.1164 29.5006 13.8544C28.6754 14.5923 27.6071 15.0002 26.5001 15C25.8279 14.9896 25.1662 14.832 24.5615 14.5383C23.9568 14.2446 23.4238 13.8219 23.0001 13.3C22.5823 13.8286 22.0506 14.256 21.4445 14.5503C20.8385 14.8447 20.1738 14.9984 19.5001 15C18.8276 14.9915 18.1652 14.8348 17.5602 14.5409C16.9552 14.2471 16.4225 13.8234 16.0001 13.3C15.5777 13.8234 15.045 14.2471 14.44 14.5409C13.835 14.8348 13.1726 14.9915 12.5001 15C11.8264 14.9984 11.1617 14.8447 10.5557 14.5503C9.94963 14.256 9.41789 13.8286 9.0001 13.3C8.57318 13.8183 8.03954 14.2384 7.43554 14.5318C6.83155 14.8252 6.1714 14.9849 5.5001 15C4.39305 15.0002 3.32477 14.5923 2.49956 13.8544C1.67434 13.1164 1.1501 12.1002 1.0271 11L7.0001 2H25.0001L30.9731 11Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path d="M13 30V22H19V30" stroke={color} strokeWidth="2" strokeMiterlimit="10" />
        </g>
        <defs>
            <clipPath id="clip0_9520_40239">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
